import { get, post, del } from "aws-amplify/api";

export const SubscriptionService = {
  // Get user's subscription status
  async getSubscriptionStatus() {
    try {
      const response = await get({
        apiName: 'userApi',
        path: '/subscription'
      });
      
      return response.body;
    } catch (error) {
      console.error('Error fetching subscription status:', error);
      throw error;
    }
  },
  
  // Subscribe to an author's newsletter
  async subscribeToNewsletter(authorUsername, email) {
    try {
      const response = await post({
        apiName: 'userApi',
        path: '/subscribe',
        options: {
          body: {
            authorUsername,
            email
          }
        }
      });
      
      return response.body;
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    }
  },
  
  // Unsubscribe from an author's newsletter
  async unsubscribeFromNewsletter(authorUsername, email) {
    try {
      const response = await del({
        apiName: 'userApi',
        path: `/subscribe/${authorUsername}`,
        options: {
          body: {
            email
          }
        }
      });
      
      return response.body;
    } catch (error) {
      console.error('Error unsubscribing from newsletter:', error);
      throw error;
    }
  },
  
  // Create a paid subscription
  async createSubscription(authorUsername, planId) {
    try {
      const response = await post({
        apiName: 'userApi',
        path: '/subscription',
        options: {
          body: {
            authorUsername,
            planId
          }
        }
      });
      
      // This would typically return a checkout URL or session ID
      return response.body;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  },
  
  // Cancel a paid subscription
  async cancelSubscription() {
    try {
      const response = await del({
        apiName: 'userApi',
        path: '/subscription'
      });
      
      return response.body;
    } catch (error) {
      console.error('Error canceling subscription:', error);
      throw error;
    }
  },
  
  // Check if user has access to premium content
  async checkContentAccess(articleId) {
    try {
      const response = await get({
        apiName: 'userApi',
        path: `/content-access/${articleId}`
      });
      
      return response.body.hasAccess;
    } catch (error) {
      console.error('Error checking content access:', error);
      // Default to no access on error
      return false;
    }
  },
  
  // Get author's subscription plans
  async getAuthorPlans(authorUsername) {
    try {
      const response = await get({
        apiName: 'userApi',
        path: `/subscription-plans/${authorUsername}`
      });
      
      return response.body.plans || [];
    } catch (error) {
      console.error('Error fetching author plans:', error);
      return [];
    }
  }
};